import { Injectable } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
import { environment } from '../../environments/environment.prod';

@Injectable()
export class AppInsightsService {
  private config: Microsoft.ApplicationInsights.IConfig = {
    instrumentationKey: environment.appInsights.instrumentationKey,
  }
  constructor() {
    if (!environment.production) {
      this.config.enableDebug = true;
    }
    if (!AppInsights.config) {
      AppInsights.downloadAndSetup(this.config);
    }
    this.logPageView('Application Insights Service created.')
  }
  logPageView(name?: string, url?: string, properties?: any,
              measurements?: any, duration?: number) {
    AppInsights.trackPageView(name, url, properties, measurements, duration);
  }

  logEvent(name: string, properties?: any, measurements?: any) {
    AppInsights.trackEvent(name, properties, measurements);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/app-insights.service.ts